/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { EmailPromotion } from "./EmailPromotion";
import {
  EmailPromotionFromJSON,
  EmailPromotionFromJSONTyped,
  EmailPromotionToJSON,
  EmailPromotionToJSONTyped,
} from "./EmailPromotion";

/**
 *
 * @export
 * @interface EmailPromotionsResponse
 */
export interface EmailPromotionsResponse {
  /**
   *
   * @type {Array<EmailPromotion>}
   * @memberof EmailPromotionsResponse
   */
  items: Array<EmailPromotion>;
  /**
   *
   * @type {string}
   * @memberof EmailPromotionsResponse
   */
  scanStatus: EmailPromotionsResponseScanStatusEnum;
  /**
   *
   * @type {Date}
   * @memberof EmailPromotionsResponse
   */
  lastScannedAt: Date | null;
  /**
   *
   * @type {Date}
   * @memberof EmailPromotionsResponse
   */
  scanStartedAt: Date | null;
  /**
   *
   * @type {Date}
   * @memberof EmailPromotionsResponse
   */
  scanUpdatedAt?: Date | null;
  /**
   *
   * @type {number}
   * @memberof EmailPromotionsResponse
   */
  lookbackDays: number;
  /**
   *
   * @type {boolean}
   * @memberof EmailPromotionsResponse
   */
  hasConnectedInbox: boolean;
  /**
   *
   * @type {boolean}
   * @memberof EmailPromotionsResponse
   */
  reconnectRequired: boolean;
}

/**
 * @export
 */
export const EmailPromotionsResponseScanStatusEnum = {
  Idle: "idle",
  Queued: "queued",
  Scanning: "scanning",
  Complete: "complete",
  Partial: "partial",
  Error: "error",
} as const;
export type EmailPromotionsResponseScanStatusEnum =
  (typeof EmailPromotionsResponseScanStatusEnum)[keyof typeof EmailPromotionsResponseScanStatusEnum];

/**
 * Check if a given object implements the EmailPromotionsResponse interface.
 */
export function instanceOfEmailPromotionsResponse(
  value: object
): value is EmailPromotionsResponse {
  if (!("items" in value) || value["items"] === undefined) return false;
  if (!("scanStatus" in value) || value["scanStatus"] === undefined)
    return false;
  if (!("lastScannedAt" in value) || value["lastScannedAt"] === undefined)
    return false;
  if (!("scanStartedAt" in value) || value["scanStartedAt"] === undefined)
    return false;
  if (!("lookbackDays" in value) || value["lookbackDays"] === undefined)
    return false;
  if (
    !("hasConnectedInbox" in value) ||
    value["hasConnectedInbox"] === undefined
  )
    return false;
  if (
    !("reconnectRequired" in value) ||
    value["reconnectRequired"] === undefined
  )
    return false;
  return true;
}

export function EmailPromotionsResponseFromJSON(
  json: any
): EmailPromotionsResponse {
  return EmailPromotionsResponseFromJSONTyped(json, false);
}

export function EmailPromotionsResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EmailPromotionsResponse {
  if (json == null) {
    return json;
  }
  return {
    items: (json["items"] as Array<any>).map(EmailPromotionFromJSON),
    scanStatus: json["scan_status"],
    lastScannedAt:
      json["last_scanned_at"] == null
        ? null
        : new Date(json["last_scanned_at"]),
    scanStartedAt:
      json["scan_started_at"] == null
        ? null
        : new Date(json["scan_started_at"]),
    scanUpdatedAt:
      json["scan_updated_at"] == null
        ? undefined
        : new Date(json["scan_updated_at"]),
    lookbackDays: json["lookback_days"],
    hasConnectedInbox: json["has_connected_inbox"],
    reconnectRequired: json["reconnect_required"],
  };
}

export function EmailPromotionsResponseToJSON(
  json: any
): EmailPromotionsResponse {
  return EmailPromotionsResponseToJSONTyped(json, false);
}

export function EmailPromotionsResponseToJSONTyped(
  value?: EmailPromotionsResponse | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    items: (value["items"] as Array<any>).map(EmailPromotionToJSON),
    scan_status: value["scanStatus"],
    last_scanned_at:
      value["lastScannedAt"] == null
        ? value["lastScannedAt"]
        : value["lastScannedAt"].toISOString(),
    scan_started_at:
      value["scanStartedAt"] == null
        ? value["scanStartedAt"]
        : value["scanStartedAt"].toISOString(),
    scan_updated_at:
      value["scanUpdatedAt"] == null
        ? value["scanUpdatedAt"]
        : value["scanUpdatedAt"].toISOString(),
    lookback_days: value["lookbackDays"],
    has_connected_inbox: value["hasConnectedInbox"],
    reconnect_required: value["reconnectRequired"],
  };
}
